module.exports = __webpack_public_path__ + "img/payerr.7a151145.png";